import React, {useEffect, useState} from "react";
import apiClient from "../axios/axiosInterceptor";
import LanguageSearch from "./LanguageSearch";
import LanguageTable from "./LanguageTable";
import '../modal.scss';
import LanguageCreate from "./LanguageCreate";
import {Slide, toast} from "react-toastify";

function Languages() {
    const [languages, setLanguages] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingLanguage, setEditingLanguage] = useState(null);

    const fetchLanguages = async (name) => {
        const baseUrl = `/languages`;

        try {
            const response = await apiClient.get(baseUrl);
            if (!name) {
                setLanguages(response.data.list);
                return;
            }
            const filteredLanguages = response.data.list.filter(language =>
                language.name.toLowerCase().includes(name.toLowerCase())
            );
            setLanguages(filteredLanguages);
        } catch (error) {
            console.error('Error fetching languages:', error);
        }
    };

    useEffect(() => {
        fetchLanguages();
    }, []);

    const search = async (name) => {
        await fetchLanguages(name);
    };

    const handleCreate = () => {
        setEditingLanguage(null);
        setShowModal(true);
    };

    const handleEdit = (language) => {
        setEditingLanguage(language);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        const url = `/languages/${id}`;

        try {
            await apiClient.delete(url);
            await fetchLanguages();
        } catch (error) {
            console.error('Error deleting language:', error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmitModal = async (languageData) => {
        const url = editingLanguage ?
            `/languages/${editingLanguage.id}` :
            `/languages`;

        try {
            if (editingLanguage) {
                await apiClient.patch(url, languageData);
                toast.success('Language updated!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            } else {
                await apiClient.post(url, languageData);
                toast.success('Language created!', {
                    position: "top-right",
                    autoClose: 3000,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            }
            setShowModal(false);
            await fetchLanguages();
        } catch (error) {
            console.error('Error saving language:', error);
        }
    };

    return (
        <div className="mainBody">
            <LanguageSearch onSearch={search} onCreate={handleCreate}/>
            <LanguageTable languages={languages} onEdit={handleEdit} onDelete={handleDelete}/>
            {showModal &&
                <LanguageCreate language={editingLanguage} onClose={handleCloseModal} onSubmit={handleSubmitModal}/>}
        </div>
    );
}

export default Languages;
